

// import React, { useEffect, useState, useMemo } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/HorarioEstudiante.css";

// const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];

// export default function HorarioEstudiante() {
//   const { token } = useAuth();

//   const [horario, setHorario] = useState([]);
//   const [horas, setHoras] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   /* ======================================================
//       🔄 FETCH SEGURO (CON CANCELACIÓN)
//   ====================================================== */
//   useEffect(() => {
//     if (!token) return;

//     const controller = new AbortController();

//     const fetchHorario = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const res = await axios.get(
//           "/horario-estudiante/estudiante/mi-horario",
//           { signal: controller.signal }
//         );

//         const data = Array.isArray(res.data) ? res.data : [];

//         setHorario(data);

//         // 🔥 Generar horas únicas ordenadas correctamente
//         const horasUnicas = [
//           ...new Set(data.map((h) => h.hora_inicio)),
//         ].sort((a, b) => toMinutes(a) - toMinutes(b));

//         setHoras(horasUnicas);

//       } catch (err) {
//         if (err.name !== "CanceledError") {
//           console.error("❌ Error al obtener horario:", err);
//           setError("No se pudo cargar el horario. Intente nuevamente.");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHorario();

//     return () => controller.abort();
//   }, [token]);

//   /* ======================================================
//       🧠 UTILIDAD PROFESIONAL (EVITA BUG DE HORAS)
//   ====================================================== */
//   const toMinutes = (hora) => {
//     const [h = 0, m = 0] = hora.split(":").map(Number);
//     return h * 60 + m;
//   };

//   /* ======================================================
//       📚 BUSCAR CLASE (OPTIMIZADO)
//   ====================================================== */
//   const mapaHorario = useMemo(() => {
//     const map = {};
//     horario.forEach((h) => {
//       const key = `${h.dia}-${h.hora_inicio}`;
//       map[key] = h;
//     });
//     return map;
//   }, [horario]);

//   const getClase = (dia, hora) => {
//     return mapaHorario[`${dia}-${hora}`] || null;
//   };

//   /* ======================================================
//       🎨 RENDER STATES
//   ====================================================== */
//   if (loading) {
//     return (
//       <div className="horario-estudiante-container">
//         <p className="loading">Cargando horario...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="horario-estudiante-container">
//         <p className="error">{error}</p>
//       </div>
//     );
//   }

//   return (
//     <div className="horario-estudiante-container">
//       <h2>📅 Mi Horario</h2>

//       {horas.length === 0 ? (
//         <div className="empty-state">
//           <p>No hay horario disponible o aún no ha sido publicado.</p>
//         </div>
//       ) : (
//         <div className="table-responsive">
//           <table className="horario-table">
//             <thead>
//               <tr>
//                 <th>Hora</th>
//                 {DIAS.map((dia) => (
//                   <th key={dia}>{dia}</th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {horas.map((hora) => (
//                 <tr key={hora}>
//                   <td className="hora">{hora}</td>

//                   {DIAS.map((dia) => {
//                     const clase = getClase(dia, hora);

//                     return (
//                       <td
//                         key={dia}
//                         className={clase ? "ocupado" : "libre"}
//                       >
//                         {clase ? (
//                           <div className="clase">
//                             <strong>{clase.materia}</strong>
//                             <span>{clase.profesor}</span>
//                             <small>
//                               {clase.hora_inicio} - {clase.hora_fin}
//                             </small>
//                             <small>{clase.aula || "Sin aula"}</small>
//                           </div>
//                         ) : (
//                           <span className="libre-text">—</span>
//                         )}
//                       </td>
//                     );
//                   })}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }


///

import React, { useEffect, useState, useMemo } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import "../../style/HorarioEstudiante.css";

const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];

/**
 * Utilidad para convertir "HH:mm" a minutos totales
 * Ayuda a ordenar las horas cronológicamente en la tabla
 */
const toMinutes = (hora) => {
  if (!hora) return 0;
  const [h = 0, m = 0] = hora.split(":").map(Number);
  return h * 60 + m;
};

export default function HorarioEstudiante() {
  const { token } = useAuth();

  const [horario, setHorario] = useState([]);
  const [horas, setHoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* ======================================================
      🔄 FETCH SEGURO (CON CANCELACIÓN Y TOKEN)
  ====================================================== */
  useEffect(() => {
    // Si no hay token, no intentamos la petición para evitar errores 401
    if (!token) return;

    const controller = new AbortController();

    const fetchHorario = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await axios.get(
          "/horario-estudiante/estudiante/mi-horario",
          { signal: controller.signal }
        );

        // Validamos que la respuesta sea un array
        const data = Array.isArray(res.data) ? res.data : [];
        setHorario(data);

        // 🔥 Extraer horas de inicio únicas y ordenarlas cronológicamente
        const horasUnicas = [
          ...new Set(data.map((h) => h.hora_inicio)),
        ].sort((a, b) => toMinutes(a) - toMinutes(b));

        setHoras(horasUnicas);

      } catch (err) {
        if (err.name !== "CanceledError") {
          console.error("❌ Error al obtener horario:", err);
          setError("No se pudo cargar el horario. Intente nuevamente.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchHorario();

    // Limpieza al desmontar el componente
    return () => controller.abort();
  }, [token]);

  /* ======================================================
      🧠 MAPEO OPTIMIZADO (PARA RENDERIZADO RÁPIDO)
  ====================================================== */
  const mapaHorario = useMemo(() => {
    const map = {};
    horario.forEach((h) => {
      // Creamos una llave única por día y hora de inicio
      const key = `${h.dia}-${h.hora_inicio}`;
      map[key] = h;
    });
    return map;
  }, [horario]);

  const getClase = (dia, hora) => {
    return mapaHorario[`${dia}-${hora}`] || null;
  };

  /* ======================================================
      🎨 RENDERIZADO DE ESTADOS (CARGA Y ERROR)
  ====================================================== */
  if (loading) {
    return (
      <div className="horario-estudiante-container">
        <div className="loading-wrapper">
          <p className="loading">Cargando tu horario académico...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="horario-estudiante-container">
        <div className="error-wrapper">
          <p className="error">{error}</p>
          <button onClick={() => window.location.reload()}>Reintentar</button>
        </div>
      </div>
    );
  }

  return (
    <div className="horario-estudiante-container">
      <header className="horario-header">
        <h2>📅 Mi Horario Escolar</h2>
      </header>

      {horas.length === 0 ? (
        <div className="empty-state">
          <p>No hay horario disponible o aún no ha sido publicado para tu curso.</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="horario-table">
            <thead>
              <tr>
                <th className="th-hora">Hora</th>
                {DIAS.map((dia) => (
                  <th key={dia}>{dia}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {horas.map((hora) => (
                <tr key={hora}>
                  <td className="hora-cell">{hora}</td>

                  {DIAS.map((dia) => {
                    const clase = getClase(dia, hora);

                    return (
                      <td
                        key={`${dia}-${hora}`}
                        className={clase ? "cell-ocupado" : "cell-libre"}
                      >
                        {clase ? (
                          <div className="clase-card">
                            <strong className="materia-name">{clase.materia}</strong>
                            <span className="profesor-name">{clase.profesor}</span>
                            <div className="clase-info">
                              <small className="badge-hora">
                                {clase.hora_inicio} - {clase.hora_fin}
                              </small>
                              <small className="badge-aula">
                                📍 {clase.aula || "Por definir"}
                              </small>
                            </div>
                          </div>
                        ) : (
                          <span className="libre-dot">—</span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
